import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import Cookies from "js-cookie";

const Logo: React.FC = () => {
  const [lang, setLang] = useState("de");

  useEffect(() => {
    const locale = Cookies.get("locale");
    if (locale) setLang(locale);
  }, []);

  return (
    <Link href={`/${lang}`} prefetch={false}>
      <Image
        src="/logo-default.png"
        alt="Logo"
        width="175"
        height="60"
        priority
        sizes="(max-width: 768px) 130px, 175px"
        className="h-[45px] max-w-[130px] cursor-pointer object-contain md:w-[175px] md:max-w-[175px]"
      />
    </Link>
  );
};

export default Logo;
